import Vue from 'vue'
import VueRouter from 'vue-router'
import { canUserAccess } from '@/utils'
import auth from '@/router/auth'
import client from '@/router/client'
import store from '../store'

import knowledge from './knowledge'
import ticket from './ticket'
import topup from './topup'
import activation from './activation'
import tools from  './tools'
import ecommerce from './ecommerce'
import report from './report'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/Dashboard.vue'),
      meta: {
        pageTitle: 'Dashboard',
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true,
          },
        ],
      },
    },
    {
      path: '/dashboard/:tab',
      name: 'dashboard tab',
      component: () => import('@/views/Dashboard.vue'),
      meta: {
        action:'dashboard',
        pageTitle: 'Dashboard',
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true,
          },
        ],
      },
    },
    ...topup,
    ...client,
    ...activation,
    ...auth,
    ...knowledge,
    ...ticket,
    ...tools,
    ...ecommerce,
    ...report,
    {
      path: '/report/commission',
      name: 'report commission',
      component: () => import('@/views/Reports/Commission'),
      meta: {
        pageTitle: 'Commission Report',
        breadcrumb: [
          {
            text: 'Commission Report',
            active: true,
          },
        ],
      },
    },

    {
      path: '/setting',
      name: 'setting list',
      component: () => import('@/views/Setting.vue'),
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            active: true,
          },
        ],
      },
    },
    
    // {
    //   path: '/invoice-add',
    //   name: 'invoice list',
    //   component: () => import('@/views/Invoice/Add.vue'),
    //   meta: {
    //     pageTitle: 'Invoice',
    //     breadcrumb: [
    //       {
    //         text: 'Invoice',
    //         active: true,
    //       },
    //     ],
    //   },
    // },

    {
      path: '/virtual-card',
      name: 'vcc list',
      component: () => import('@/views/VirtualCard/CardList.vue'),
      meta: {
        resource: 'virtual-card',
        pageTitle: 'VCC List',
        breadcrumb: [
          {
            text: 'VCC List',
            active: true,
          },
        ],
      },
    },

    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})


const auth_routes = [
  'login',
  'register',
  'password-reset',
]

router.beforeEach((to, from, next) => {
  const { user } = store.state.app
  const action = to.meta.action ?to.meta.action:to.name

    // If user is not logge in , allow pages only in auth_routes
  if (user === null) {
    if (auth_routes.includes(action)) next()
    else if (action === 'password-reset') next()
    else next('login')
  } else if (auth_routes.includes(action)) next({ name: 'dashboard' })
  else if (action === 'dashboard' || action === 'email-verify' || canUserAccess(action, to.meta.resource)) next()
  else next({ name: 'error-404' })

})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
